// src/data/services.js  (example – update with your real images)
import service1 from '../Assets/images/PD.jpg'
import service2 from '../Assets/images/GC.jpg'
import service3 from '../Assets/images/Endodontic.jpeg'
import service4 from '../Assets/images/LD.jpg'
import service5 from '../Assets/images/C&B.jpg'
import service6 from '../Assets/images/Dentures.jpg'
import service7 from '../Assets/images/O&M.jpg'
import service8 from '../Assets/images/Orthodontics.jpg'
import service9 from '../Assets/images/Cosmetic Dentistry.jpg'


export default [
  {
    title: "Pediatric Dentistry",
    description: "Gentle dental care to keep children’s teeth healthy from the start.",
    image: service1,
    icon: "🦷",
    link: "teeth-checkup.php"
  },
  {
    title: "Gum Care",
    description: "Treatment and prevention of gum infections and gum disease.",
    image: service2,
    icon: "🦷",
    link: "teeth-whitening.php"
  },
  {
    title: "Endodontic",
    description: "Root canal treatment to save infected or damaged teeth.",
    image: service3,
    icon: "🦷",
    link: "orthodontist-in-hyderabad.php"
  },
  {
    title: "Laser Dentistry",
    description: "Advanced painless dental treatments using laser technology.",
    image: service4,
    icon: "🦷",
    link: "dental-implants-cilinic-hyderabad.php"
  },
  {
    title: "Crowns & Bridges",
    description: "Restores damaged or missing teeth for strength and appearance.",
    image: service5,
    icon: "🦷",
    link: "dental-filling.php"
  },
  {
    title: "Dentures",
    description: "Custom artificial teeth to replace missing natural teeth.",
    image: service6,
    icon: "🦷",
    link: "cosmetic-dentist-in-hyderabad.php"
  },
  {
    title: "Oral & Maxillofacial Surgery",
    description: "Surgical treatment for complex dental and jaw conditions.",
    image: service7,
    icon: "🦷",
    link: "cosmetic-dentist-in-hyderabad.php"
  },
  {
    title: "Orthodontics",
    description: "Aligns crooked teeth and corrects bite problems for a confident, well-balanced smile.",
    image: service8,
    icon: "🦷",
    link: "cosmetic-dentist-in-hyderabad.php"
  },
  {
    title: "Cosmetic Dentistry",
    description: "Enhances your smile with whitening and aesthetic treatments.",
    image: service9,
    icon: "🦷",
    link: "cosmetic-dentist-in-hyderabad.php"
  },
];
